import clsx from "clsx";
import { ClaimIcon, MerchDropIcon, PollIcon } from "components/atoms/Icon";
import { ExpiryTimer } from "components/organisms/merchdrop/UserMerchViewModal";
import DefaultImage from "../../assets/Images/BrandImage1.png";
import { AirdropMementoIcon } from "../../components/atoms/Icon";
import { activationKeyUserDescriptionMap } from "../../constants";

type Props = {
  name: string;
  imageUrl: string;
  additionalClasses?: string;
  mementoType: ActivationsKeys;
  actionPending?: boolean;
};

interface ClickableCard extends Props {
  isClickable: boolean;
  handleOnClick: () => void;
}
interface ViewOnlyCard extends Props {
  isClickable?: never;
  handleOnClick?: never;
}

const getMementoIcon = (mementoName: string, actionPending?: boolean, classNames?: string) => {
  switch (mementoName) {
    case "mem_drop":
      return (
        <AirdropMementoIcon
          className={classNames || "h-3 w-3 md:h-5 md:w-5"}
          color={actionPending ? "text-[#000080]" : undefined}
        />
      );
    case "merch_drop":
      return (
        <MerchDropIcon
          className={classNames || "h-3 w-3 md:h-5 md:w-5"}
          color={actionPending ? "text-[#000080]" : undefined}
        />
      );
    case "claim_code":
      return (
        <ClaimIcon
          className={classNames || "h-3 w-3 md:h-5 md:w-5"}
          color={actionPending ? "text-[#000080]" : undefined}
        />
      );
    case "poll":
      return (
        <PollIcon
          className={classNames || "h-3 w-3 md:h-5 md:w-5"}
          color={actionPending ? "text-[#000080]" : undefined}
        />
      );
    default:
      return (
        <AirdropMementoIcon
          className={classNames || "h-3 w-3 md:h-5 md:w-5"}
          color={actionPending ? "text-[#000080]" : undefined}
        />
      );
  }
};

export default function BrandPublicProfileMementoCardHorizontal({
  name,
  imageUrl,
  additionalClasses = "",
  isClickable = false,
  handleOnClick,
  mementoType,
  actionPending,
  endTime,
}: (ClickableCard | ViewOnlyCard) & { endTime: number | null }) {
  return (
    <div
      className={clsx("flex w-40 flex-row gap-x-2 font-satoshi lg:w-52", isClickable && "cursor-pointer")}
      tabIndex={0}
      onKeyDown={() => {}}
      role="button"
      onClick={(e) => {
        e.stopPropagation();
        if (handleOnClick) handleOnClick();
      }}
    >
      <div className="relative">
        <div className="md aspect-1  w-14">
          <img
            src={imageUrl || DefaultImage}
            alt={name}
            className={clsx(
              "h-full w-full rounded border-[0.1px] object-cover   md:rounded-ll md:border ",
              actionPending ? "border-accent" : "border-white border-opacity-30",
            )}
          />
        </div>
        <div
          className={clsx(
            "absolute bottom-0 right-0 rounded-br rounded-tl  p-1 md:rounded-br-ll  md:rounded-tl-ll",
            actionPending ? "bg-yellow-400" : "bg-[#8B8B8B] opacity-80",
          )}
        >
          {getMementoIcon(mementoType, actionPending, "w-3 h-3")}
        </div>
      </div>
      <div className="mr-1 overflow-hidden pr-1 text-[10px] font-bold text-white">
        <p className="text-[10px]  text-accent">{activationKeyUserDescriptionMap[mementoType]}</p>
        <p
          className={clsx(
            "mt-0.5 truncate text-left font-satoshi",
            " font-bold  leading-5 text-white first-letter:uppercase sm:text-base md:text-xxs 2xl:mt-1",
            additionalClasses,
          )}
        >
          {name}
        </p>
        <div className="text-base font-normal opacity-60">
          {mementoType !== "mem_drop" && <ExpiryTimer showTimeAfterExpiry={false} endTime={endTime} />}
        </div>
      </div>
    </div>
  );
}
